<template>
    <div id="mhcc">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="addthis_sharing_toolbox float-right"
                         addthis:url="https://www.nsc.org/forms/substance-use-employer-calculator/index.aspx"
                         addthis:title="Mental Health Cost Calculator - National Safety Council"
                    >
                    </div>
                </div>
            </div>
            <div id="Questions">
                <div class="row">
                    <div class="col-md-8">
                        <Header/>
                        <h2 class="txtgreen clear mt-5 mb-3" style="font-size: 22px">
                            Calculate Your Workplace Costs
                        </h2>
                        <div v-for="location in state.locations" :key="location.id">
                            <StateSelector :id="location.id"></StateSelector>
                        </div>

                        <div class="row">
                            <div class="col">
                                <button id=""
                                        class="btn mb-4 float-right btn-select addStateButt px-3 py-2 bgnscblue"
                                        @click="addLocation()"
                                >
                                    Add Additional State
                                </button>
                            </div>
                        </div>
                        <IndustrySelector/>
                        <div class="row mt-3 emailsubresults">
                            <div class="col-sm-6 col-md-7">
                                <div class="form-group">
                                    <input type="text"
                                           name="EmailAddress"
                                           id="EmailAddress"
                                           v-model="state.email"
                                           class="form-control form-control-lg"
                                           placeholder="Email Address"
                                           maxlength="50"
                                    />
                                    <p class="small muted mt-2">
                                        We will email you the results of this calculator.
                                    </p>
                                    <span v-if="state.emailError"
                                          id="EmailAddressError"
                                          class="help-block"
                                    >
                                        Please enter a valid email address longer than six
                                        characters.
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-5">
                                <div class="form-group">
                                    <button type="button"
                                            class="btn btn-block btn-lg bgnscblue"
                                            id="FinalSubmitBtn"
                                            @click="advance"
                                            data-loading-text=" <i class='fa fa-circle-o-notch fa-spin'></i> Processing..."
                                    >
                                        Get Your Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <RightColumn/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../store.js';
    import StateSelector from "@/components/StateSelector";
    import RightColumn from '@/components/RightColumn';
    import Header from '@/components/Header';
    import IndustrySelector from "@/components/IndustrySelector";

    export default {
        components: {
            IndustrySelector,
            StateSelector,
            RightColumn,
            Header
        },
        data() {
            return {
                state: store.state,
                selectedTab: 0,
                industry: "NA",
                industryErrors: false,
                email: "",
                emailErrors: false,
            };
        },
        mounted() {
            if (store.debug) {
                console.log("calc-root-store", store);
                console.log("calc-root-static", this.state)
            }
            store.clearLocations();
            store.addLocation();
        },
        methods: {
            log(event) {
                if (store.debug)
                    console.log(event);
            },
            addLocation() {
                store.addLocation();
            },
            advance() {
                if (store.debug) {
                    console.log("calling submit function");
                }
                if (store.validate()) {
                    store.computeResults();
                    let uriInfo = store.getURIInfo();
                    let resultsurl =`${window.location}results?industry=${uriInfo.industry}&locations=${uriInfo.locations}`
                        
                    let result = this.sendEmail(resultsurl, this.state.email);
                    console.log("api result", result);
                    this.$router.push({path: '/results', query: uriInfo});
                }
            },
            async sendEmail(url, email) {
                let submiturl = window.location.protocol + "//" + window.location.host + '/tools/api/mail';
                const response = await fetch(submiturl, {
                    method: "POST",
                    mode: "cors",
                    cache: "no-cache",
                    headers: {
                        'Content-Type': 'application/json',
                        '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
                    },
                    body: JSON.stringify({resultsLink: url, email: email})
                }).then(function(response) { console.log("api response", response)});
                return response;
            },
            showModal(modal) {
                store.showModal(modal);
            },
            hideModal() {
                store.hideModal();
            }
        }
    };
</script>

<style scoped>
</style>